import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Tenant } from '../models/tenant.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TenantService {


    private selectedTenantId: number | null = null;
      url = `${environment.url}/api`;

      constructor(
        private http: HttpClient
      ) { }


    getTenants(): Observable<Tenant[]> {
        return this.http.get<{ tenants: Tenant[] }>(`${this.url}/tenants`).pipe(
            map(response => response.tenants)
        );
    }

    createTenat(data: Tenant): Observable<Tenant> {
        return this.http.post<Tenant>(`${this.url}/tenants`, data);
    }

    getTenantbySlug(slug: string): Observable<Tenant> {
        const slugToUse = slug || 'mkc';
        // return this.http.get<Tenant>(`${this.url}/tenants/mostrarBySlug/${slug}`);
        return this.http.get<Tenant>(`${this.url}/tenants/mostrarBySlug/${slugToUse}`);
    }

    // tenant.service.ts
    setTenantInBackend(tenantId: string): Observable<any> {
        return this.http.post<any>(`${this.url}/tenants/select`, { tenant_id: tenantId });
    }


}

